


















































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import MyForm from "@/mixins/form";
import { number } from "echarts/core";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  other_items:any=[]

    // 添加规则配置项
  addOther(item:any,index: number) {
    console.log('other:',this.other_items)
    this.other_items.push({
      name: "",
      value: ""
    });
  }

  removeOther(item:any,index: number) {
    console.log('other:',this.other_items)
    this.$confirm({
      title: "确认信息",
      content: "确定要移除吗？",
      onOk: () => {
        this.other_items.splice(index, 1);
        if(this.other_items.length==0){
          this.addOther({},0)
        }
      }
    });
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        const other:any=this.other_items.filter((o:any,i:number)=>{
          return o.value!=''
        })
        const x:any=other.find((o:any,i:number)=>o.name=='')
        if(x){
          this.$message.error("请输入自定义成本名称")
          return
        }
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要提交保存吗？",
          onOk: async () => {
            const values: any = {};
            for (const key in fieldValues) {
              if (
                ["cost_before", "cost_salary_before", "cost_os_before", "earn_before","rent_before","water_before"].includes(key)
              ) {
                _.set(values, [key], fieldValues[key] * 100);
              } else {
                _.set(values, [key], fieldValues[key]);
              }
            }
            const res = await this.$store.dispatch("stadium/saveTaisamSetting", {
              stadium_id: this.stadiumId,
              other_before:JSON.stringify(other),
              ...values
            });
            if (res && res.Message && res.Message == "success") {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  async mounted() {
    const res = await this.$store.dispatch("stadium/getTaisamSetting", {
      stadium_id: this.stadiumId
    });
    // console.log(res);
    if (res && res.Data) {
      this.formData = res.Data;
      if(this.formData.other_before){
        this.other_items=JSON.parse(this.formData.other_before)
      }
      if(this.other_items.length==0){
        this.addOther({},0)
      }
    }
  }
}
